import { useState, useEffect } from "react";

const LOGO_URL = "https://storage.readdy-site.link/project_files/91d33e52-58d2-42bb-9fc0-529365f1aafc/371b55df-6645-4987-b0c7-b039d0a07bb2_taurus.jpg?v=7463f65f750d1c25236e63c68a6b56d1";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        className="fixed top-0 left-0 w-full z-50 transition-all duration-500 bg-white border-b border-stone-100"
        style={{ height: "88px" }}
      >
        <div className="w-full px-6 lg:px-12 h-full flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="Taurus Contracting"
              className="h-16 w-auto object-contain"
            />
          </a>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:4167241172"
              className="flex items-center gap-2 text-sm font-medium px-5 py-2.5 rounded-sm border border-stone-300 text-stone-700 hover:border-stone-800 hover:text-stone-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <i className="ri-phone-line text-sm"></i>
              (416) 724-1172
            </a>
            <button
              onClick={() => scrollTo("contact")}
              className="text-sm font-semibold px-6 py-2.5 rounded-sm bg-stone-900 text-white hover:bg-stone-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif", letterSpacing: "0.06em" }}
            >
              GET A FREE QUOTE
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-sm text-stone-800 hover:bg-stone-100 transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 transition-all duration-500 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        style={{ background: "rgba(15,15,15,0.97)" }}
      >
        <div className="flex flex-col items-center justify-center h-full gap-2 px-8">
          <div className="flex items-center gap-3 mb-10">
            <img
              src={LOGO_URL}
              alt="Taurus Contracting"
              className="h-14 w-auto object-contain brightness-0 invert"
            />
          </div>
          {[
            { id: "services", label: "Services" },
            { id: "process", label: "Process" },
            { id: "areas", label: "Service Areas" },
            { id: "testimonials", label: "Testimonials" },
            { id: "faq", label: "FAQ" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 text-2xl font-light tracking-widest cursor-pointer hover:text-white transition-colors py-3 w-full text-center"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {item.label}
            </button>
          ))}
          <div className="mt-8 flex flex-col gap-3 w-full max-w-xs">
            <a
              href="tel:4167241172"
              className="flex items-center justify-center gap-2 text-white border border-white/30 px-8 py-4 rounded-sm text-sm tracking-widest hover:bg-white hover:text-stone-900 transition-all"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <i className="ri-phone-line"></i>
              (416) 724-1172
            </a>
            <button
              onClick={() => scrollTo("contact")}
              className="bg-white text-stone-900 px-8 py-4 rounded-sm text-sm font-semibold tracking-widest hover:bg-stone-100 transition-all cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              GET A FREE QUOTE
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
